import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SidebarContentTypes } from 'constants/enums';

interface SidebarState {
  showSidebar: boolean;
  contentId: SidebarContentTypes | null;
  activeUserId: string;
  isBlockUrlHandling: boolean;
  // workaround to switch tabs on big sidebar
  activeSidebarTabId: number | null;
}

const initialState: SidebarState = {
  showSidebar: false,
  contentId: null,
  activeUserId: '',
  isBlockUrlHandling: false,
  activeSidebarTabId: null
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.showSidebar = !state.showSidebar;
      state.isBlockUrlHandling = false;
    },
    setActiveUserId: (state, action: PayloadAction<string>) => {
      state.activeUserId = action.payload;
      state.isBlockUrlHandling = false;
    },
    setSidebarContent(
      state,
      action: PayloadAction<{
        contentId: SidebarContentTypes | null;
        activeUserId?: string | null;
      }>
    ) {
      if (!state.showSidebar) {
        state.showSidebar = true;
      }
      state.contentId = action.payload.contentId;
      state.activeUserId = action.payload.activeUserId || '';
      state.isBlockUrlHandling = false;
    },
    closeSidebar(state) {
      state.showSidebar = false;
      state.contentId = null;
      state.activeUserId = '';
      state.isBlockUrlHandling = false;
    },
    closeSidebarForAction(state) {
      state.showSidebar = false;
      state.isBlockUrlHandling = true;
    },
    setActiveSidebarTabId: (state, action: PayloadAction<number | null>) => {
      state.activeSidebarTabId = action.payload;
    }
  }
});

export const {
  toggleSidebar,
  setActiveUserId,
  setSidebarContent,
  closeSidebar,
  closeSidebarForAction,
  setActiveSidebarTabId
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
